import { asset } from "@/lib/asset";
import { useState, useEffect } from 'react';

const partners = [
    {
        id: 1,
        image: asset('/img/partners/home/mkb.png'),
        alt: 'МКБ',
        style: 'w-[94px] lg:w-[281px]',
        order: 8
    },
    {
        id: 2,
        image: asset('/img/partners/home/sber.png'),
        alt: 'Сбер',
        style: 'w-[98px] lg:w-[274px]',
        order: 2
    },
    {
        id: 3,
        image: asset('/img/partners/home/aeroflot/logo-allprints_AFL_without_ST-02.png'),
        alt: 'Аэрофлот',
        style: 'w-[136px] lg:w-[276px]',
        order: 11
    },
    {
        id: 4,
        image: asset('/img/partners/home/rostec.png'),
        alt: 'Ростелеком',
        style: 'w-[58px] lg:w-[132px]',
        order: 6
    },
    {
        id: 5,
        image: asset('/img/partners/home/komus.png'),
        alt: 'Комус',
        style: 'w-[146px] lg:w-[241px]',
        order: 12
    },
    {
        id: 6,
        image: asset('/img/partners/home/rosseti.png'),
        alt: 'Россети',
        style: 'w-[105px] lg:w-[275x]',
        order: 1
    },
    {
        id: 7,
        image: asset('/img/partners/home/evraz.png'),
        alt: 'Евраз',
        style: 'w-[128px] lg:w-[320px]',
        order: 9
    },
    {
        id: 9,
        image: asset('/img/partners/home/rosbank.png'),
        alt: 'Росбанк',
        style: 'w-[141px] lg:w-[237px]',
        order: 10
    },
    {
        id: 10,
        image: asset('/img/partners/home/Renaissance_Bank.svg'),
        alt: 'Ренессанс Банк',
        style: 'w-[136px] lg:w-[276px]',
        order: 11
    },
    {
        id: 11,
        image: asset('/img/partners/home/rosselhozbank.png'),
        alt: 'Россельхозбанк',
        style: 'w-[191px] lg:w-[282px]',
        order: 7
    },
    {
        id: 12,
        image: asset('/img/partners/home/min-agric.png'),
        alt: 'Министерство сельского хозяйства',
        style: 'w-[65px] lg:w-[113px]',
        order: 4
    },{
        id: 13,
        image: asset('/img/partners/home/vtb.svg'),
        alt: 'ОТКРИТИЕ',
        style: 'w-[136px] lg:w-[276px]',
        order: 12
    },{
        id: 14,
        image: asset('/img/partners/home/domrf.svg'),
        alt: 'Дом.РФ Банк',
        style: 'w-[136px] lg:w-[276px]',
        order: 12
    },{
        id: 15,
        image: asset('/img/partners/home/RGS.png'),
        alt: 'Росгосстрах',
        style: 'w-[136px] lg:w-[276px]',
        order: 12
    },{
        id: 16,
        image: asset('/img/partners/home/pb.svg'),
        alt: 'Банк Санкт-Петербург ',
        style: 'w-[136px] lg:w-[276px]',
        order: 12
    },{
        id: 17,
        image: asset('/img/partners/home/Domclick.svg'),
        alt: 'ДомКлик',
        style: 'w-[136px] lg:w-[276px]',
        order: 12
    },{
        id: 18,
        image: asset('/img/partners/home/rivegauche.svg'),
        alt: 'Рив Гош',
        style: 'w-[136px] lg:w-[276px]',
        order: 12
    },{
        id: 8,
        image: asset('/img/partners/home/gprf.png'),
        alt: 'ГПРФ',
        style: 'w-[66px] lg:w-[114px]',
        order: 12
    },
];

export default function Partners() {
    return (
        <div className="container mx-auto">
            
            <div className="flex flex-col justify-center items-center  ">
                
                <div className='w-full max-w-[320px] md:max-w-full flex justify-start items-start md:justify-center mt-[90px] xl:mt-[118px] xl:mb-[5px]'>

                    <div className="lg:text-center text-[20px] xl:text-3xl font-extrabold font-['Open Sans'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text">
                        Нам доверяют:
                    </div>
                </div>

                <div className="flex flex-wrap md:grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-[20px] md:gap-[60px] lg:gap-[80px] xl:gap-[100px] justify-content-center items-center max-w-[320px] md:max-w-full lg:max-w-[780px] xl:max-w-[1215px] mt-[30px] xl:mt-[60px]">
                    {partners.map((partner) => (
                        <div
                            key={partner.id}
                            className={`
                                mb-[28px]
                                text-center
                                ${getOrderClass(partner.order)}
                                ${getLgOrderClass(partner.id)}
                            `}
                        >
                            <img src={partner.image} alt={partner.alt} className={`w-full h-full object-contain max-w-[126px] max-h-[276px]`} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}


function getOrderClass(order) {
    const orderClasses = {
        1: 'order-1',
        2: 'order-2',
        3: 'order-3',
        4: 'order-4',
        5: 'order-5',
        6: 'order-6',
        7: 'order-7',
        8: 'order-8',
        9: 'order-9',
        10: 'order-10',
        11: 'order-11',
        12: 'order-12',
        13: 'order-13',
        14: 'order-14',
        15: 'order-15',
        16: 'order-16',
        17: 'order-17',
        18: 'order-18'
    };
    // return orderClasses[order] || '';
}

function getLgOrderClass(id) {
    const orderClasses = {
        1: 'lg:order-1',
        2: 'lg:order-2',
        3: 'lg:order-3',
        4: 'lg:order-4',
        5: 'lg:order-5',
        6: 'lg:order-6',
        7: 'lg:order-7',
        8: 'lg:order-8',
        9: 'lg:order-9',
        10: 'lg:order-10',
        11: 'lg:order-11',
        12: 'lg:order-12',
        13: 'lg:order-13',
        14: 'lg:order-14',
        15: 'lg:order-15',
        16: 'lg:order-16',
        17: 'lg:order-17',
        18: 'lg:order-18'
    };
    // return orderClasses[id] || '';
}
